interface Props {
    className?: string;
}

export function BaggageInsuranceIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M66.31 83.29H38.89c-4.35 0-7.89-3.53-7.89-7.86V41.09c0-4.33 3.54-7.86 7.89-7.86h27.42c4.35 0 7.9 3.53 7.9 7.86v34.34c0 4.33-3.54 7.86-7.9 7.86ZM38.9 35.31c-3.21 0-5.81 2.59-5.81 5.78v34.34c0 3.19 2.61 5.78 5.81 5.78h27.42c3.21 0 5.81-2.59 5.81-5.78v-34.34c0-3.19-2.61-5.78-5.81-5.78H38.9Z"
                fill="currentColor"
            />
            <path
                d="M41.29 89.25c-2.5 0-4.54-2.03-4.54-4.54v-2.46h2.08v2.46c0 1.35 1.1 2.45 2.46 2.45s2.45-1.1 2.45-2.45v-2.46h2.08v2.46c0 2.5-2.03 4.54-4.54 4.54Z"
                fill="currentColor"
            />
            <path
                d="M63.92 89.25c-2.5 0-4.54-2.03-4.54-4.54v-2.46h2.08v2.46c0 1.35 1.1 2.45 2.46 2.45s2.46-1.1 2.46-2.45v-2.46h2.08v2.46c0 2.5-2.04 4.54-4.54 4.54Z"
                fill="currentColor"
            />
            <rect x="43.3" y="13.9" width="2.08" height="20.12" fill="currentColor" />
            <rect x="46.43" y="13.9" width="2.08" height="20.12" fill="currentColor" />
            <rect x="56.7" y="13.9" width="2.08" height="20.12" fill="currentColor" />
            <rect x="59.83" y="13.9" width="2.08" height="20.12" fill="currentColor" />
            <path
                d="M61.11 14.85H44.1c-1.42 0-2.57-1.15-2.57-2.57V9.86c0-1.42 1.15-2.57 2.57-2.57h17.01c1.42 0 2.57 1.15 2.57 2.57v2.42c0 1.42-1.15 2.57-2.57 2.57ZM44.1 9.38c-.27 0-.49.22-.49.49v2.42c0 .27.22.49.49.49h17.01c.27 0 .49-.22.49-.49V9.86c0-.27-.22-.49-.49-.49H44.1Z"
                fill="currentColor"
            />
            <path
                d="M40.48 74.04c-.57 0-1.04-.47-1.04-1.04V43.52c0-.57.47-1.04 1.04-1.04s1.04.47 1.04 1.04V73c0 .57-.47 1.04-1.04 1.04Z"
                fill="currentColor"
            />
            <path
                d="M52.6 74.04c-.57 0-1.04-.47-1.04-1.04V43.52c0-.57.47-1.04 1.04-1.04s1.04.47 1.04 1.04V73c0 .57-.47 1.04-1.04 1.04Z"
                fill="currentColor"
            />
            <path
                d="M64.72 74.04c-.57 0-1.04-.47-1.04-1.04V43.52c0-.57.47-1.04 1.04-1.04s1.04.47 1.04 1.04V73c0 .57-.47 1.04-1.04 1.04Z"
                fill="currentColor"
            />
        </svg>
    );
}
